import React from 'react';
import { render } from '@testing-library/react';
import { Tooltip } from './Tooltip';

describe('Tooltip', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<Tooltip
				direction="top"
				text="Tooltip"
				portal
				open
				data-auto-sel="automation-selector"
			>
				<div>Hover(Touch) here for tooltip</div>
			</Tooltip>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});

	it('should pass data automation attributes to portal', () => {
		const { container, baseElement } = render(
			<Tooltip
				direction="top"
				text="Tooltip"
				portal
				open
				portalDataAttributes={{
					'data-auto-sel': 'automation-selector',
				}}
			>
				<div>Hover(Touch) here for tooltip</div>
			</Tooltip>
		);

		const nonPortalElement = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);
		const portalElement = baseElement.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(nonPortalElement).toBeNull();
		expect(portalElement).not.toBeNull();
	});
});
